import { useOptionalUser } from './auth-context';

/**
 * Phiên đang ở **không gian cá nhân** (`AuthenticatedUser.isPersonal`) — APM-PSPACE-b.
 *
 * Giao diện **ẩn** (không làm mờ) thứ không có ở đó: tab Nhân sự / Thay đổi / Thiết kế, nút mời,
 * tải tệp, thêm tài liệu, đính kèm. Cửa chặn thật nằm ở API (`PERSONAL_SPACE_RESTRICTED`); đây chỉ
 * để người dùng khỏi bấm vào một cửa đóng. `false` khi chưa có phiên (test không dựng AuthProvider).
 */
export function useOrgIsPersonal(): boolean {
  return useOptionalUser()?.isPersonal === true;
}
